import React from 'react';
import { Box, BoxProps } from '../../wag-react/next-components/box';
export type ScalableProps = BoxProps;
/**
 * TODO - move to wag-react
 */
export const Scalable = ({
  children,
  ...rest
}: ScalableProps) => <Box overflow="hidden" css={{
  transition: 'transform .2s',
  ':hover': {
    transform: 'scale(1.02)'
  }
}} {...rest} data-sentry-element="Box" data-sentry-component="Scalable" data-sentry-source-file="index.tsx">
    {children}
  </Box>;